import { Component, Input } from '@angular/core';

export interface MetadataUser {
    firstName?: string;
    lastName?: string;
}

@Component({
    selector: 'app-metadata-footer',
    templateUrl: './metadata-footer.component.html',
    styleUrls: ['./metadata-footer.component.scss'],
    standalone: false
})
export class MetadataFooterComponent {
    @Input() createdAt: Date | string | null = null;
    @Input() updatedAt: Date | string | null = null;
    @Input() createdBy: MetadataUser | null = null;
    @Input() updatedBy: MetadataUser | null = null;

    /** Alternative: accept a pre-formatted name string instead of user object */
    @Input() createdByName: string | null = null;
    @Input() updatedByName: string | null = null;

    /**
     * Get the display name for the creator.
     * Prefers the string name if provided, otherwise builds from user object.
     */
    get createdByDisplayName(): string | null {
        if (this.createdByName) {
            return this.createdByName;
        }
        if (this.createdBy) {
            return [this.createdBy.firstName, this.createdBy.lastName].filter(Boolean).join(' ') || null;
        }
        return null;
    }

    /**
     * Get the display name for the last updater.
     * Prefers the string name if provided, otherwise builds from user object.
     */
    get updatedByDisplayName(): string | null {
        if (this.updatedByName) {
            return this.updatedByName;
        }
        if (this.updatedBy) {
            return [this.updatedBy.firstName, this.updatedBy.lastName].filter(Boolean).join(' ') || null;
        }
        return null;
    }

    /**
     * Check if updatedAt is different from createdAt (i.e., the item was actually updated).
     */
    get hasBeenUpdated(): boolean {
        if (!this.updatedAt || !this.createdAt) {
            return false;
        }
        const createdStr = this.createdAt.toString().substring(0, 19);
        const updatedStr = this.updatedAt.toString().substring(0, 19);
        return createdStr !== updatedStr;
    }
}
